"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = undefined;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Column = exports.Column = function () {
  function Column(idx, width, cubeRatio) {
    (0, _classCallCheck3.default)(this, Column);

    this.idx = idx;
    this.groups = [];
    this.height = 0;
    this.width = width;
    this.cubeRatio = cubeRatio;
  }

  (0, _createClass3.default)(Column, [{
    key: "addGroup",
    value: function addGroup(group) {
      this.addGroups([group]);
    }
  }, {
    key: "addGroups",
    value: function addGroups(groups) {
      var _this = this;

      this.groups = this.groups.concat(groups);
      groups.forEach(function (group) {
        return group.columnIdx = _this.idx;
      });
    }
  }, {
    key: "scheme",
    get: function get() {
      return {
        idx: this.idx,
        groups: this.groups.map(function (group) {
          return group.scheme;
        }),
        width: this.width,
        height: this.height
      };
    }
  }]);
  return Column;
}();